import { render, staticRenderFns } from "./AwardTermEditor.vue?vue&type=template&id=302630f6"
import script from "./AwardTermEditor.vue?vue&type=script&lang=js"
export * from "./AwardTermEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports